import { UserSpecialsService } from './../../../services/user-specials/user-specials.service';
import { SubSink } from 'subsink';
import { ModalController, ToastController } from '@ionic/angular';
import { PlatformService } from './../../../services/platform/platform.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-specials-settings',
  templateUrl: './specials-settings.page.html',
  styleUrls: ['./specials-settings.page.scss'],
})
export class SpecialsSettingsPage implements OnInit {
  isMobileDevice: boolean;
  specialsForm: FormGroup;
  subscription = new SubSink();
  isCreate: boolean = true;

  showSpinner: boolean = false;

  response_message: string = '';
  hasResponseError: boolean = false;

  constructor(
    private fb: FormBuilder,
    private platform: PlatformService,
    private modalCtrl: ModalController,
    private toast: ToastController,
    private specialsService: UserSpecialsService
  ) {
    this.isMobileDevice = this.platform.isMobile();
  }

  ngOnInit() {
    this.readySpecialsForm();
    this.getSpecialsData();
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
  }

  //GETTERS
  get mondaySpecial() {
    return this.specialsForm.get('monday_specials');
  }

  get tuesdaySpecial() {
    return this.specialsForm.get('tuesday_specials');
  }

  get wednesdaySpecial() {
    return this.specialsForm.get('wednesday_specials');
  }

  get thursdaySpecial() {
    return this.specialsForm.get('thursday_specials');
  }

  get fridaySpecial() {
    return this.specialsForm.get('friday_specials');
  }

  get saturdaySpecial() {
    return this.specialsForm.get('saturday_specials');
  }

  get sundaySpecial() {
    return this.specialsForm.get('sunday_specials');
  }
  //GETTERS

  readySpecialsForm() {
    this.specialsForm = this.fb.group({
      monday_specials: ['', Validators.pattern(/\S+/)],
      tuesday_specials: ['', Validators.pattern(/\S+/)],
      wednesday_specials: ['', Validators.pattern(/\S+/)],
      thursday_specials: ['', Validators.pattern(/\S+/)],
      friday_specials: ['', Validators.pattern(/\S+/)],
      saturday_specials: ['', Validators.pattern(/\S+/)],
      sunday_specials: ['', Validators.pattern(/\S+/)],
    });
  }

  readyFormData(res: any) {
    this.specialsForm.patchValue({
      monday_specials: res.monday_specials ?? '',
      tuesday_specials: res.tuesday_specials ?? '',
      wednesday_specials: res.wednesday_specials ?? '',
      thursday_specials: res.thursday_specials ?? '',
      friday_specials: res.friday_specials ?? '',
      saturday_specials: res.saturday_specials ?? '',
      sunday_specials: res.sunday_specials ?? '',
    });
  }

  async getSpecialsData() {
    this.subscription.sink = await this.specialsService
      .getUserSpecials()
      .subscribe(
        (res_specials: any) => {
          let specials_response: any = {
            monday_specials: res_specials[0].specials,
            tuesday_specials: res_specials[1].specials,
            wednesday_specials: res_specials[2].specials,
            thursday_specials: res_specials[3].specials,
            friday_specials: res_specials[4].specials,
            saturday_specials: res_specials[5].specials,
            sunday_specials: res_specials[6].specials
          }
          this.readyFormData(specials_response);
          this.isCreate = false;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  updateSpecials() {
    this.showSpinner = true;
    let specials_data: any = {
      specials : [
        {
          day: 'Monday',
          specials: this.mondaySpecial.value,
        },
        {
          day: 'Tuesday',
          specials: this.tuesdaySpecial.value,
        },
        {
          day: 'Wednesday',
          specials: this.wednesdaySpecial.value,
        },
        {
          day: 'Thursday',
          specials: this.thursdaySpecial.value,
        },
        {
          day: 'Friday',
          specials: this.fridaySpecial.value,
        },
        {
          day: 'Saturday',
          specials: this.saturdaySpecial.value,
        },
        {
          day: 'Sunday',
          specials: this.sundaySpecial.value,
        }
      ]
    }
    if (this.isCreate) {
      this.subscription.sink = this.specialsService
        .createUserSpecials(specials_data)
        .subscribe(
          (res: any) => {
            this.isCreate = false;
            this.showSpinner = false;
            // console.log('create specials response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);
          },
          (err: any) => {
            this.showSpinner = false;
            // console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred adding your Specials, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
    } else {
      this.subscription.sink = this.specialsService
        .updateUserSpecials(specials_data)
        .subscribe(
          (res: any) => {
            this.showSpinner = false;
            // console.log('update specials response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);
          },
          (err: any) => {
            this.showSpinner = false;
            // console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred updating your Specials, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
    }
  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  closeModal() {
    return this.modalCtrl.dismiss();
  }
}
